import script from "./landing-page.vue?vue&type=script&setup=true&lang=js"
export * from "./landing-page.vue?vue&type=script&setup=true&lang=js"

import "./landing-page.vue?vue&type=style&index=0&id=92c47676&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92c47676"]])

export default __exports__